export enum LoadingTypes {
  SHOW = `@loading/SHOW`,
  HIDE = `@loading/HIDE`,
}

export interface LoadingState {
  readonly toggle: boolean
}
